var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloonYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.168,
    height: 125.699,
    viewBox: "0 0 50.168 125.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.609,117.29c-3.169,1.088-3.908,5.386-2.82,8.539s6.48,11.9,6.48,25.6c0,12.706-10.952,23.325-15.578,28.987",
    transform: "translate(-12.595 -55.351)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.168,25.084c0,13.852-11.232,35.963-25.084,35.963S0,38.936,0,25.084a25.084,25.084,0,1,1,50.168,0Z",
    fill: "#f2994a",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.757,118.207a4.156,4.156,0,0,0-4.837,0V116h4.837Z",
    transform: "translate(-20.255 -54.742)",
    fill: "#f2994a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43,115.41a5.339,5.339,0,0,0,4.843,0",
    transform: "translate(-20.292 -54.464)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.531,28.164c2.92,0,5.281-2.841,5.281-6.337s-2.366-6.337-5.281-6.337-5.281,2.841-5.281,6.337S59.605,28.164,62.531,28.164Z",
    transform: "translate(-27.017 -7.31)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonYellow);
export default __webpack_public_path__ + "static/media/balloon_yellow.556a8b15afa0ea49311ac4c8ff832fd0.svg";
export { ForwardRef as ReactComponent };